import {Component, OnInit, Input, Output, EventEmitter, OnChanges} from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})

export class NavbarComponent implements OnChanges {
  @Input() logo = '../../assets/images/logo-branca.svg';
  @Input() logoLink = '/';
  @Input() menuLista = [{label: 'Menu Item', icon: '../../assets/images/menu-icons/logout.svg'}];
  @Input() menuTriggerLabel = 'Abrir Menu';
  @Output() menuItemClicked = new EventEmitter<{}>();
  menuWithSubmenus = [];
  menuWithUrl = [];

  constructor() {
  }

  clickMenu(menu) {
    this.menuItemClicked.emit(menu);
  }

  filterMenu(menuLista) {
    menuLista.map(menu => {
      if (menu.submenus) {
        this.menuWithSubmenus.push(menu);
      }
      if (menu.url) {
        this.menuWithUrl.push(menu);
      }
    });
  }

  ngOnChanges(changes) {
    if (changes.menuLista && changes.menuLista.currentValue.length) {
      this.filterMenu(changes.menuLista.currentValue);
    }
  }
}
